export const DBNBIZ_SUBSCRIPTIONS_RESET_STATE = 'DBNBIZ_SUBSCRIPTIONS_RESET_STATE';
export const DBNBIZ_SUBSCRIPTIONS_CURRENT_ITEM = 'DBNBIZ_SUBSCRIPTIONS_CURRENT_ITEM';

export const DBNBIZ_SUBSCRIPTIONS_REQUEST_LOADING = 'DBNBIZ_SUBSCRIPTIONS_REQUEST_LOADING';
export const DBNBIZ_SUBSCRIPTIONS_REQUEST_SUCCESS = 'DBNBIZ_SUBSCRIPTIONS_REQUEST_SUCCESS';
export const DBNBIZ_SUBSCRIPTIONS_REQUEST_FAILED = 'DBNBIZ_SUBSCRIPTIONS_REQUEST_FAILED';

export const DBNBIZ_SUBSCRIPTIONS_CURRENT_ACTION = 'DBNBIZ_SUBSCRIPTIONS_CURRENT_ACTION';
export const DBNBIZ_SUBSCRIPTIONS_RESET_ACTION = 'DBNBIZ_SUBSCRIPTIONS_RESET_ACTION';
